import React from "react";
import Hero from "@/components/home/Hero";
import StatsStrip from "@/components/home/StatsStrip";
import Benefits from "@/components/home/Benefits";
import HowItWorks from "@/components/home/HowItWorks";
import Transparency from "@/components/home/Transparency";
import ImageryBlocks from "@/components/home/ImageryBlocks";
import ContactForm from "@/components/home/ContactForm";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <StatsStrip />
      <Benefits />
      <HowItWorks />
      <Transparency />
      <ImageryBlocks />
      <ContactForm />
    </div>
  );
}
